// «Модули и функции» (decision 025): the owner switches parts of apps; nothing is deleted, switching back returns everything.
// A block of rows per app on the template of «Настройки» (DESIGN.md «Настройки»).

import { useEffect, useState } from 'react';
import { PageBlock } from '../ui/Page.tsx';
import { Field, Switch, useToast } from '../ui/primitives.tsx';
import s from './settings.module.css';

/** `plan: false` — the client's plan excludes the feature (decision 030): shown off, not switchable here. */
interface Feature { key: string; app: string; appName: string; name: string; description: string; requires: string[]; on: boolean; plan?: false }

async function call(method: 'GET' | 'POST', body?: unknown): Promise<{ features?: Feature[]; error?: { message: string } }> {
  const r = await fetch('/api/features', { method, credentials: 'same-origin', ...(body ? { headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) } : {}) });
  return r.json().catch(() => ({ error: { message: 'Сервер не ответил' } }));
}

export function FeaturesPane() {
  const toast = useToast();
  const [list, setList] = useState<Feature[] | null>(null);
  const [busy, setBusy] = useState<string | null>(null);
  useEffect(() => { void call('GET').then((r) => (r.features ? setList(r.features) : toast({ kind: 'error', text: r.error?.message ?? 'Не удалось загрузить' }))); }, [toast]);
  const name = (key: string) => list?.find((f) => f.key === key)?.name ?? key;
  const flip = async (f: Feature) => {
    setBusy(f.key);
    const r = await call('POST', { key: f.key, on: !f.on });
    setBusy(null);
    // On success the server asks every open tab to reload, so the menu and cards change at once.
    if (r.features) setList(r.features); else toast({ kind: 'error', text: r.error?.message ?? 'Не удалось переключить' });
  };
  if (!list) return <p className={s.lead}>Загрузка…</p>;
  const apps = [...new Set(list.map((f) => f.appName))];
  return (
    <>
      {apps.map((a) => (
        <PageBlock key={a} title={a} rows>
          {list.filter((f) => f.appName === a).map((f) => (
            <Field key={f.key} as="div" inline="end" label={f.name} hint={<>
              {f.description}
              {f.requires.length > 0 && <span className={s.needs}>Нужна: {f.requires.map(name).join(', ')}</span>}
              {f.plan === false && <span className={s.needs}>Недоступна на тарифе</span>}
            </>}>
              <Switch checked={f.on} disabled={busy !== null || f.plan === false} onChange={() => void flip(f)} label={f.name} />
            </Field>
          ))}
        </PageBlock>
      ))}
    </>
  );
}
